import React from 'react';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Iconify } from '@sdf/base';
import Box from '@mui/material/Box';

interface Props {
  showToolTip?: boolean;
}

export const ProgressStuckNote: React.FC<Props> = ({
  showToolTip = false
}) => {

  return (
    
    <Stack direction="row" gap={1}>
      <Tooltip 
        title={
            showToolTip ? 'If progress bar is stuck for long, try refreshing the page.' : ''
        }
      >
      <Box>
        <Iconify
          icon={'heroicons-outline:information-circle'}
          width={'20px'}
          height={'20px'}
          color={(theme) =>
            showToolTip ? theme.palette.text.primary : theme.palette.text.placeholder
          }
        />
      </Box>
      </Tooltip>
      {!showToolTip && (
        <Typography 
          fontSize={13} 
          fontStyle="italic" 
          color={(theme) => theme.palette.text.placeholder}
        >
          If the progress bar is stuck for long, try refreshing the page.
        </Typography>
    )}
    </Stack>
)};